// set mobile app name, age and location
function init() {
  var age = document.querySelector('.card-header .age');
  if(age){
    age.textContent = Math.ceil(Math.random() * (35 - 22) + 22) + " ";
  }
}

document.addEventListener('DOMContentLoaded', init);